import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./hidden_special_offers_content.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
